import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
const Hero = () => {
  return <section className="relative bg-gradient-to-r from-promred-gray to-gray-700 text-white py-20 md:py-28" data-id="element-277">
      <div className="absolute inset-0 overflow-hidden" data-id="element-278">
        <div className="absolute -top-10 -right-10 w-72 h-72 rounded-full bg-promred-red opacity-20 blur-3xl" data-id="element-279"></div>
        <div className="absolute top-40 -left-20 w-80 h-80 rounded-full bg-promred-blue opacity-20 blur-3xl" data-id="element-280"></div>
        <div className="absolute bottom-0 right-1/4 w-60 h-60 rounded-full bg-promred-yellow opacity-20 blur-3xl" data-id="element-281"></div>
      </div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-282">
        <div className="max-w-3xl" data-id="element-283">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-284">
            Soluciones de Gestión de Eventos
          </h1>
          <p className="text-lg md:text-xl mb-8 text-gray-100" data-id="element-285">
            Potenciamos y gestionamos la operativa y tecnología de tus eventos.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-286">
            <a href="#servicios" className="bg-promred-red hover:bg-red-700 text-white font-semibold px-6 py-3 rounded-md transition-colors inline-flex items-center justify-center" data-id="element-287">
              Nuestros servicios
              <ChevronRightIcon size={20} className="ml-2" data-id="element-288" />
            </a>
            <a href="/programas-clientes" className="bg-white hover:bg-gray-100 text-promred-gray font-semibold px-6 py-3 rounded-md transition-colors inline-flex items-center justify-center" data-id="element-289">
              Nuestros Clientes
            </a>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;